import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BlockApp } from 'src/app/models/BlockApp';
import { BlockService } from 'src/app/services/block.service';
import { getToken } from 'src/app/shared/global';
@Component({
  selector: 'app-app-block',
  templateUrl: './app-block.component.html',
  styleUrls: ['./app-block.component.scss']
})
export class AppBlockComponent implements OnInit {

  public form: FormGroup;
  block : BlockApp = new BlockApp();

  constructor(private spinner: NgxSpinnerService, private toastr: ToastrService, private blockService: BlockService,private router: Router) { }

  ngOnInit() {

    this.form = new FormGroup({
      'dateFrom': new FormControl('', Validators.required),
      'dateTo': new FormControl('', Validators.required),
      'description': new FormControl('', Validators.required)
    });
  }

  submit() {
    this.spinner.show();
    if(this.form.value['dateTo'] != "" && this.form.value['dateFrom'] != "" && this.form.value['description'] != "") {
      let dateTo = this.form.value['dateTo']; 
      let dateFrom = this.form.value['dateFrom'];
      let description = this.form.value['description'];
      if(dateTo < dateFrom) {
        this.toastr.error("LA FECHA INICIO DEBE SER MENOR A LA DE FIN");
        this.spinner.hide();
      }
      else {
        this.block.initialDate = dateFrom;
        this.block.endDate = dateTo;
        this.block.description = description;
        this.blockService.postBlockApp(this.block).subscribe(
          data=> {
            if (getToken(data)) {  
              this.toastr.success("SE GUARDARON LOS DATOS");
              this.spinner.hide();
              this.router.navigate(['home']);
            } else{
              this.spinner.hide();
              this.toastr.error("HA OCURRIDO UN ERROR AL GENERAR EL JUSTIFICANTE", "ERROR");
            }
          }, error => {
            this.toastr.error("NO SE PUDO GUARDAR LOS DATOS");
            this.spinner.hide();
          });
      }
    }
    else {
      this.toastr.error("HAS DE RELLENAR TODOS LOS DATOS");
      this.spinner.hide();
    }
  }
}